export const environment = {
  production: true,
  serverUrl: 'https://onlinebusiness.icbc.com/clipapi/v1',
  defaultLanguage: 'en-CA',
  supportedLanguages: ['en-CA', 'fr-CA'],
  name: 'PRD',
  recaptchaSiteKey: "6Lf90wEAAAAAAJ8y6DFYslrYzy38rLdsQEK7-zsH",
  portalHomeUrl: "https://my.icbc.com",
  oauth2SessionBaseUrl: "https://idp.icbc.com",
  oauth2SignOutUrl: "https://idp.icbc.com/ssologout",
  oauth2TimeOutUrl: "https://www.icbc.com/app-timed-out",
  oauth2RedirectUri: "https://onlinebusiness.icbc.com/clipui/v1/oauth2/callback",
  oauth2ApiEndpoint: "https://auth.icbc.com/f5-oauth2/v1",
  oauth2SessionCheckEndpoint: "https://idp.icbc.com/vdesk/timeoutagent-i.php",
  oauth2SessionUpdateEndpoint: "https://idp.icbc.com/sessionupdate",
  oauth2ClientId: "e406c7ac19053d9083fa8aba6d1c0094a138f5f884e72769",
};  
    